(function () {
  const POPUP_ID = "offer-info-notification-popup";
  let lastClickedCollections = [];

  function getConfig() {
    return window.notDiscountPopupConfig || null;
  }

  function getPopup() {
    return document.getElementById(POPUP_ID);
  }

  function showPopup() {
    const popup = getPopup();
    if (!popup) return;
    popup.style.display = "flex";
    requestAnimationFrame(() => popup.classList.add("show"));
    document.body.classList.add("popup-open");
  }

  function closePopup() {
    const popup = getPopup();
    if (!popup) return;
    popup.classList.remove("show");
    document.body.classList.remove("popup-open");
    setTimeout(() => (popup.style.display = "none"), 300);
  }

  function shouldShowPopup(productCollections) {
    const config = getConfig();
    if (!config || !config.enabled) return false;

    const selected = (config.selectedCollectionIds || []).map(String);
    const product = (productCollections || []).map(String);
  // ✅ If no collections selected → show for all products
  if (selected.length === 0) {
    return true;
  }
    // Show only if product NOT in selected collections
  return !product.some(id => selected.includes(id));
  }

  function handleCartAdd() {
    if (shouldShowPopup(lastClickedCollections)) {
      showPopup();
    }
  }

  // Track clicked product collections
  document.addEventListener("click", (e) => {
    const button = e.target.closest("[data-product-collections]");
    if (!button) return;
    try {
      lastClickedCollections = JSON.parse(button.dataset.productCollections || "[]");
    } catch {
      lastClickedCollections = [];
    }
  });

  // Intercept Fetch cart add
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const isCartAdd = typeof args[0] === "string" && args[0].includes("/cart/add");
    return originalFetch.apply(this, args).then((response) => {
      if (isCartAdd && response.ok) handleCartAdd(); // only on success
      return response;
    });
  };

  // Intercept XHR cart add
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartAdd = typeof url === "string" && url.includes("/cart/add");
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartAdd) {
      this.addEventListener("load", function () {
        if (this.status === 200) handleCartAdd(); // only on success
      });
    }
    return origSend.apply(this, arguments);
  };

  // Popup close buttons
  document.addEventListener("DOMContentLoaded", function () {
    document
      .getElementById("offer-info-notification-popup-close")
      ?.addEventListener("click", closePopup);
    document
      .querySelector("#offer-info-notification-popup .popup-ok-btn")
      ?.addEventListener("click", closePopup);
    document
      .querySelector("#offer-info-notification-popup .popup-explore-btn")
      ?.addEventListener("click", function () {
        const popup = getPopup();
        const link = popup?.dataset.buttonLink;
        if (link) window.location.href = link;
        closePopup();
      });
  });
})();